/** Shared, environment-independent public brand identity. */
export const brandConfig = {
	name: 'DeepMox',
	supportEmail: 'support@deepmox.com',
} as const;
